import React, { useState } from "react";
import { toast } from "sonner";
import { Btn, Card, Field, Input, Select, TextArea } from "./ui";
import { UploadField } from "./UploadField";
import { ProvLoc } from "./ProvLoc";
import { errMsg, todayLocal as today } from "./api";
const EMPTY = { titulo: "", descripcion: "", fecha: today(), provincia: "", localidad: "", categoria: "", autor: "", es_recreacion: false, visibilidad: "colaboradores" };

// Admin form: every upload requires full metadata before it is saved to the library.
export const ContenidoForm = ({ client, meta, onCreated }) => {
  const [f, setF] = useState(EMPTY);
  const [file, setFile] = useState(null);
  const [thumb, setThumb] = useState(null);
  const [busy, setBusy] = useState(false);
  const [k, setK] = useState(0);
  const set = (p) => setF((x) => ({ ...x, ...p }));

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Subí el archivo antes de guardar");
    setBusy(true);
    try {
      await client.post("/contenidos", { ...f, file_id: file.file_id, thumb_file_id: thumb?.file_id || "" });
      toast.success("Contenido guardado en la biblioteca");
      setF(EMPTY);
      setFile(null);
      setThumb(null);
      setK((x) => x + 1);
      onCreated?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card title="Cargar contenido" testid="red-cargar">
      <form onSubmit={submit} className="grid md:grid-cols-2 gap-5" key={k}>
        <Field label="Archivo (video o imagen) *" className="md:col-span-2">
          <UploadField client={client} onUploaded={setFile} testid="cargar-archivo" />
        </Field>
        <Field label="Título *" className="md:col-span-2">
          <Input required minLength={3} value={f.titulo} onChange={(e) => set({ titulo: e.target.value })} data-testid="cargar-titulo" />
        </Field>
        <Field label="Descripción *" className="md:col-span-2">
          <TextArea required minLength={3} value={f.descripcion} onChange={(e) => set({ descripcion: e.target.value })} data-testid="cargar-descripcion" />
        </Field>
        <Field label="Categoría *">
          <Select required value={f.categoria} placeholder="Elegí…" options={meta.categorias} onChange={(e) => set({ categoria: e.target.value })} data-testid="cargar-categoria" />
        </Field>
        <Field label="Fecha *">
          <Input type="date" required value={f.fecha} onChange={(e) => set({ fecha: e.target.value })} data-testid="cargar-fecha" />
        </Field>
        <ProvLoc meta={meta} provincia={f.provincia} localidad={f.localidad} onChange={set} testid="cargar" />
        <Field label="Autor *">
          <Input required minLength={2} value={f.autor} onChange={(e) => set({ autor: e.target.value })} data-testid="cargar-autor" />
        </Field>
        <Field label="Visible para">
          <Select value={f.visibilidad} options={[{ value: "colaboradores", label: "Solo colaboradores" }, { value: "publico", label: "Colaboradores y biblioteca pública" }]} onChange={(e) => set({ visibilidad: e.target.value })} data-testid="cargar-visibilidad" />
        </Field>
        <Field label="Miniatura (opcional, para videos)" className="md:col-span-2">
          <UploadField client={client} accept="imagen" onUploaded={setThumb} testid="cargar-miniatura" label="Elegir miniatura" />
        </Field>
        <label className="md:col-span-2 flex items-start gap-3 p-3 border border-purple-200 bg-purple-50 cursor-pointer">
          <input type="checkbox" checked={f.es_recreacion} onChange={(e) => set({ es_recreacion: e.target.checked })} className="mt-1 accent-purple-700" data-testid="cargar-recreacion" />
          <span className="text-sm text-[#0A192F]">
            <strong>Es un montaje digital / recreación</strong> (pasacalles o murales virtuales, fotomontajes). Se mostrará con la etiqueta "Recreación digital".
          </span>
        </label>
        <div className="md:col-span-2">
          <Btn type="submit" busy={busy} disabled={!file} data-testid="cargar-submit">Guardar en la biblioteca</Btn>
        </div>
      </form>
    </Card>
  );
};

export default ContenidoForm;
